'use strict';

var dateFnsTz = require('date-fns-tz');
var constants = require('../constants.cjs');

const timestampToParts = ({ timeZone, timestamp }) => {
  return {
    timeZoneOffset: dateFnsTz.formatInTimeZone(
      timestamp,
      timeZone,
      constants.ISO_TIME_ZONE_OFFSET_FORMAT
    ),
    date: dateFnsTz.formatInTimeZone(timestamp, timeZone, constants.ISO_DATE_PART_FORMAT),
    time: dateFnsTz.formatInTimeZone(timestamp, timeZone, constants.ISO_TIME_PART_FORMAT)
  };
};

module.exports = timestampToParts;
//# sourceMappingURL=timestampToParts.cjs.map
